/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type FeatureFlagApiResourceKey = typeof FeatureFlagApiResourceKey[keyof typeof FeatureFlagApiResourceKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureFlagApiResourceKey = {
  bs_webhook_after_booking_update: 'bs_webhook_after_booking_update',
  ru_webhook_after_booking_update: 'ru_webhook_after_booking_update',
  auto_checkin_enabled: 'auto_checkin_enabled',
  auto_checkout_enabled: 'auto_checkout_enabled',
  cancel_expired_tentative_reservations_enabled: 'cancel_expired_tentative_reservations_enabled',
  auto_update_property_status_enabled: 'auto_update_property_status_enabled',
  forward_booking_sync_enabled: 'forward_booking_sync_enabled',
  booking_sync_command_enabled: 'booking_sync_command_enabled',
  rentals_united_sync_command_enabled: 'rentals_united_sync_command_enabled',
  forward_audit_log_enabled: 'forward_audit_log_enabled',
  block_processing_enabled: 'block_processing_enabled',
  early_checkin_enabled: 'early_checkin_enabled',
  booking_sync_webhook_enabled: 'booking_sync_webhook_enabled',
  rentals_united_webhook_enabled: 'rentals_united_webhook_enabled',
  rentals_united_outbound_push_enabled: 'rentals_united_outbound_push_enabled',
  legacy_push_sync_enabled: 'legacy_push_sync_enabled',
} as const;
